export const GET_TEACHER_MARK = "GET_TEACHER_MARK";